module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "bodymatter",
      "id": "rpt1",
      "title": "Part I: Place in Geocritical Theory and Practice"
    }
  }, [_c('p', {
    staticClass: "pn"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "title": "15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253037695_Contents#pt1"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" I")])])]), _vm._v(" "), _c('p', {
    staticClass: "pt"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253037695_Contents#pt1"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LACE IN")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EOCRITICAL")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEORY AND")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RACTICE")])]), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "title": "16"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-754a99a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253037695_Part_1.vue
// module id = 84
// module chunks = 0